import { PartnerProfileEditDto } from '@diritto/common/account/dtos/partner-profile-edit.dto';
import { PartnerProfileImageResponseDto } from '@diritto/common/account/dtos/partner-profile-image.response.dto';
import { PartnerProfileResponseDto } from '@diritto/common/account/dtos/partner-profile.response.dto';
import { ProfilesResponseDto } from '@diritto/common/account/dtos/profiles.response.dto';
import { ResponseDto } from '@diritto/common/base/response.dto';
import { Http } from '@diritto/common/utils/requester/http';
import { AxiosRequestConfig } from 'axios';
import { PartnersResponseDto } from '@diritto/common/partner/dtos/partner.dto';
import { generateUrl } from '@diritto/common/utils/urls';

export class PartnerApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async findPartnerById(partnerId: number, options?: AxiosRequestConfig) {
    const res = await this.http.get<PartnerProfileResponseDto>(`${this.url}/accounts/partners/${partnerId}`, options);
    return res.data;
  }

  async getMyProfiles() {
    const res = await this.http.get<ProfilesResponseDto>(`${this.url}/accounts/profiles/me`);
    return res.data;
  }

  async updateProfile(params: PartnerProfileEditDto) {
    const res = await this.http.patch<PartnerProfileEditDto, PartnerProfileResponseDto>(
      `${this.url}/accounts/partners/me`,
      params,
    );
    return res.data;
  }

  async uploadProfileImage(data: FormData): Promise<PartnerProfileImageResponseDto> {
    const res = await this.http.post<FormData, PartnerProfileImageResponseDto>(
      `${this.url}/accounts/partners/me/images`,
      data,
    );
    return res.data;
  }

  async deleteProfileImage(id: number) {
    const res = await this.http.delete<ResponseDto>(`${this.url}/accounts/profiles/me/images/${id}`);
    return res.data;
  }

  async findByIds(partnerIds: number[]) {
    const res = await this.http.get<PartnersResponseDto>(generateUrl(`${this.url}/partners`, { partnerIds }));
    return res.data;
  }
}
